import { supabase } from '../lib/supabase';

// This key should be stored securely and rotated periodically
// In production, this should be stored in environment variables
const ENCRYPTION_KEY = import.meta.env.VITE_PII_ENCRYPTION_KEY || 'your-secure-encryption-key';



export const piiService = {
  async updatePlayerPII(playerId: string, phone?: string, email?: string) {
    
    const { error } = await supabase.rpc('update_player_pii', {
      player_id: playerId,
      phone: phone || null,
      email: email || null,
      encryption_key: ENCRYPTION_KEY
    });

    if (error) {
      console.error('Error updating PII:', error);
      throw error;
    }
  },

  async getPlayerPII(playerId: string) {
    
    const { data, error } = await supabase.rpc('get_player_pii', {
      player_id: playerId,
      encryption_key: ENCRYPTION_KEY
    });

    if (error) {
      console.error('Error getting PII:', error);
      throw error;
    }
    
    // The RPC function returns an array with a single row when using RETURNS TABLE
    // Extract the data from the array if needed
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    }
    
    return data;
  },

  async updateCoachPII(coachId: string, phone?: string, email?: string) {
    
    const { error } = await supabase.rpc('update_coach_pii', {
      coach_id: coachId,
      phone: phone || null,
      email: email || null,
      encryption_key: ENCRYPTION_KEY
    });

    if (error) {
      console.error('Error updating PII:', error);
      throw error;
    }
  },

  async getCoachPII(coachId: string) {
    
    const { data, error } = await supabase.rpc('get_coach_pii', {
      coach_id: coachId,
      encryption_key: ENCRYPTION_KEY
    });

    if (error) {
      console.error('Error getting PII:', error);
      throw error;
    }
    
    // The RPC function returns an array with a single row when using RETURNS TABLE
    // Extract the data from the array if needed
    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    }
    
    return data;
  },

  // Helper function to validate phone number format
  validatePhoneNumber(phone: string): boolean {
    // Remove any non-digit characters
    const digits = phone.replace(/\D/g, '');
    // Check if the result is 10 digits
    return digits.length === 10;
  },

  // Helper function to validate email format
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}; 